

































import {Component, Prop, Vue} from 'vue-property-decorator';
import {IOrderSupplierSelection} from '@/screens/dashboard/orders/OrderTrackingExportScreen.vue';
import {DataTableHeader} from 'vuetify';
import LineItemView from '@/components/LineItemView.vue';
import SupplierSelect from '@/components/SupplierSelect.vue';
import {ISupplier} from '@/models/ISupplier';


@Component({
  components: {
    LineItemView,
    SupplierSelect
  }
})


export default class OrderSupplierSelectionTable extends Vue {
  @Prop() orders!: IOrderSupplierSelection[];
  @Prop() value!: IOrderSupplierSelection[];
  @Prop() suppliers!: ISupplier[];
  headers: DataTableHeader[] = [
    { text: 'Order', value: 'order_id', width: 100, sortable: true },
    { text: 'Country', value: 'shipping_address.country', width: 100, sortable: true },
    { text: 'Products', value: 'line_items', sortable: true },
    { text: 'Supplier', value: 'line_items', sortable: true, width: 400 },
  ];



  suppliersOfProduct(lineItem: any) {
    return this.suppliers.filter((supplier) => supplier.products.some((product) => product.sp_product_id === lineItem.product_id));
  }

  onItemSelect(item: IOrderSupplierSelection) {
    this.$emit('toggle', item);
  }

  onInputChange(value: IOrderSupplierSelection[]) {
    this.$emit('input', value);
  }
}
